function subscribe(eventName: string, listener: any) {
  if (eventName && listener && document) {
    document.addEventListener(eventName, listener);
  }
}

function unsubscribe(eventName: string, listener: any) {
  if (eventName && listener && document) {
    document.removeEventListener(eventName, listener);
  }
}

function triggerEvent(event: Event) {
  if (event && document) {
    document.dispatchEvent(event);
  }
}
function triggerEventWithMessage(eventName: string, obj: object = {}) {
  if (eventName && document) {
    const customEvent = new CustomEvent(eventName, { detail: obj });
    document.dispatchEvent(customEvent);
  }
}

export { subscribe, triggerEvent, triggerEventWithMessage, unsubscribe };
